export default import.meta.ROLLDOWN_FILE_URL_TttZKAImyQ5RIG6_MhVTMA